import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelCatEaster: FC<SvgIconProps> = ({ viewBox = '0 0 255 180', ...props }) => (
  <SvgIcon viewBox={viewBox} height="180" width="255" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M126.813 167.22c66.574 0 120.544-7.444 120.544-16.626 0-9.183-53.97-16.627-120.544-16.627-66.575 0-120.545 7.444-120.545 16.627 0 9.182 53.97 16.626 120.545 16.626Z"
      fill="#007C39"
    />
    <path
      opacity=".1"
      d="M34.132 148.986c0 .679-3.962 1.206-8.784 1.206-4.822 0-8.785-.527-8.785-1.206 0-.679 3.963-1.219 8.785-1.219s8.784.568 8.784 1.219Z"
      fill="#000"
    />
    <path
      d="M38.774 134.729c0 7.399-6.027 14.299-13.426 14.299-7.4 0-13.44-6.928-13.44-14.299 0-7.371 4.309-20.16 13.44-20.16 8.438 0 13.426 12.747 13.426 20.16Z"
      fill="url(#paint0_linear_6616_41481)"
    />
    <g opacity=".3">
      <path
        opacity=".3"
        d="M34.825 121.469a31.866 31.866 0 0 1 1.205 7.399c0 7.925-6.373 15.324-14.299 15.324a13.11 13.11 0 0 1-8.092-2.771 13.302 13.302 0 0 0 11.709 7.565c7.398 0 13.426-6.928 13.426-14.299a27.225 27.225 0 0 0-3.95-13.218Z"
        fill="url(#paint1_linear_6616_41481)"
      />
    </g>
    <path
      d="M17.616 118.393a20.117 20.117 0 0 0-2.951 4.6c3.2.586 6.446.883 9.699.887a67.135 67.135 0 0 0 11.417-1.026 20.323 20.323 0 0 0-3.104-4.544 64.93 64.93 0 0 1-8.313.568 48.364 48.364 0 0 1-6.748-.485Z"
      fill="#FFF7E4"
    />
    <path
      opacity=".1"
      d="M231.714 152.879c0 .97-5.404 1.663-12.055 1.663-6.65 0-12.054-.831-12.054-1.663 0-.831 5.404-1.662 12.054-1.662 6.651 0 12.055.693 12.055 1.662Z"
      fill="#000"
    />
    <path
      d="M12.905 127.815a28.837 28.837 0 0 0-.886 4.919c4.084.977 8.27 1.47 12.47 1.468a68.867 68.867 0 0 0 14.16-1.551 27.01 27.01 0 0 0-.97-4.822 67.58 67.58 0 0 1-13.19 1.385 51.36 51.36 0 0 1-11.584-1.399ZM12.323 137.998a14.956 14.956 0 0 0 2.771 5.709c3.11.553 6.263.832 9.422.831a66.057 66.057 0 0 0 11.265-.998 14.967 14.967 0 0 0 2.619-5.542 66.904 66.904 0 0 1-13.856 1.538 50.364 50.364 0 0 1-12.22-1.538Z"
      fill="#FFF7E4"
    />
    <path
      opacity=".1"
      d="M53.253 152.464c0 .693-3.616 1.206-8.106 1.206-4.489 0-8.091-.513-8.091-1.206s3.616-1.205 8.091-1.205c4.476 0 8.106.693 8.106 1.205Z"
      fill="#000"
    />
    <path
      d="M55.483 135.934c2.065 6.54-1.385 14.119-7.925 16.184-6.54 2.064-13.606-2.411-15.67-8.951-2.065-6.54-1.719-18.775 6.207-21.366 7.579-2.23 15.504 7.579 17.389 14.133Z"
      fill="url(#paint2_linear_6616_41481)"
    />
    <path d="M43.762 127.662a1.731 1.731 0 1 0-1.718-1.718 1.717 1.717 0 0 0 1.718 1.718Z" fill="#FFDF5F" />
    <path
      d="M41.157 121.538a1.58 1.58 0 0 0-.125.845 1.706 1.706 0 0 0 1.94 1.469 1.39 1.39 0 0 0 .416-.139v.167a1.76 1.76 0 0 0 2.244 1.205 1.663 1.663 0 0 0 1.206-1.178 11.834 11.834 0 0 0-5.681-2.369Z"
      fill="#FFDF5F"
    />
    <path
      d="M41.864 126.221a1.716 1.716 0 0 0 1.006-2.458 1.72 1.72 0 0 0-1.688-.893 1.718 1.718 0 1 0 .682 3.351Z"
      fill="#FFDF5F"
    />
    <path d="M43.263 124.905a.86.86 0 1 0-.002-1.72.86.86 0 0 0 .002 1.72Z" fill="#FFF7E4" />
    <path
      d="M52.56 132.969a1.73 1.73 0 0 0 1.718 1.732 1.67 1.67 0 0 0 .748-.194 25.883 25.883 0 0 0-2.702-4.919 1.714 1.714 0 0 0-1.563 1.711 1.717 1.717 0 0 0 1.563 1.711l.236-.041ZM38.22 129.048a1.806 1.806 0 0 1-1.545 1.273 1.8 1.8 0 1 1 .339-3.518 2.084 2.084 0 0 1 1.205 2.245ZM37.236 132.83a1.798 1.798 0 0 1-1.545 1.272 1.8 1.8 0 0 1-1.575-2.932 1.806 1.806 0 0 1 1.914-.585 1.83 1.83 0 0 1 1.206 2.245Z"
      fill="#FFDF5F"
    />
    <path
      d="M37.402 132.664a1.802 1.802 0 1 1 2.245-1.205 1.829 1.829 0 0 1-2.245 1.205ZM33.786 131.624a1.795 1.795 0 0 1-1.273-1.544 1.8 1.8 0 0 1 1.965-1.973 1.803 1.803 0 0 1 1.552 2.312 1.742 1.742 0 0 1-2.244 1.205Z"
      fill="#FFDF5F"
    />
    <path
      d="M36.834 130.765a.995.995 0 0 1-1.206.693.983.983 0 0 1-.692-1.205.967.967 0 0 1 1.205-.693.983.983 0 0 1 .693 1.205Z"
      fill="#FFF7E4"
    />
    <path
      d="M44.981 133.177a1.816 1.816 0 1 1-1.898-1.718 1.87 1.87 0 0 1 1.898 1.718ZM45.147 137.139a1.818 1.818 0 0 1-1.046 1.727 1.814 1.814 0 0 1-1.835-3.113c.291-.211.638-.332.997-.346a1.775 1.775 0 0 1 1.884 1.732Z"
      fill="#FFDF5F"
    />
    <path
      d="M45.328 136.959a1.815 1.815 0 1 1 1.718-1.829 1.996 1.996 0 0 1-1.718 1.829ZM41.365 137.139a1.813 1.813 0 0 1-1.441-3.03 1.81 1.81 0 0 1 1.958-.491 1.812 1.812 0 0 1 1.2 1.623 1.869 1.869 0 0 1-1.717 1.898Z"
      fill="#FFDF5F"
    />
    <path
      d="M44.288 135.241a.971.971 0 0 1-.859 1.04.955.955 0 0 1-.805-1.561.957.957 0 0 1 .639-.338c.499-.18.859.347 1.025.859Z"
      fill="#FFF7E4"
    />
    <path
      d="M54.278 134.895a1.818 1.818 0 0 1-1.036 1.736 1.818 1.818 0 0 1-2-.299 1.818 1.818 0 0 1 .154-2.808c.29-.212.638-.333.998-.347a1.88 1.88 0 0 1 1.884 1.718Z"
      fill="#FFDF5F"
    />
    <path
      d="M50.69 135.13a1.813 1.813 0 0 1-1.422-3.036 1.815 1.815 0 0 1 3.154 1.138 2.218 2.218 0 0 1-1.732 1.898Z"
      fill="#FFDF5F"
    />
    <path
      d="M53.46 132.997a.954.954 0 0 1-.504.939.954.954 0 0 1-1.357-1.137.956.956 0 0 1 .837-.661 1.078 1.078 0 0 1 1.025.859Z"
      fill="#FFF7E4"
    />
    <path
      d="M51.867 144.025a1.729 1.729 0 0 0 1.239-2.956 1.737 1.737 0 0 0-1.894-.373 1.733 1.733 0 0 0-.556 2.822c.322.322.757.504 1.211.507ZM49.456 145.744a1.775 1.775 0 0 1-2.563-2.041 1.778 1.778 0 0 1 1.505-1.273 1.776 1.776 0 0 1 1.751.903 1.737 1.737 0 0 1-.153 1.971 1.721 1.721 0 0 1-.54.44Z"
      fill="#FFDF5F"
    />
    <path
      d="M49.637 145.744a1.775 1.775 0 1 1 2.41.692 1.732 1.732 0 0 1-2.41-.692ZM47.738 142.474a1.773 1.773 0 1 1 2.411.693 1.917 1.917 0 0 1-2.41-.693Z"
      fill="#FFDF5F"
    />
    <path
      d="M50.69 144.026a.892.892 0 0 1-.982-.082.892.892 0 0 1-.3-.939.888.888 0 0 1 1.628-.185.767.767 0 0 1 .143.694.759.759 0 0 1-.49.512Z"
      fill="#FFF7E4"
    />
    <path
      d="M42.917 145.398a1.782 1.782 0 0 1-1.964-.165 1.768 1.768 0 0 1-.6-1.877 1.771 1.771 0 0 1 1.505-1.272 1.775 1.775 0 0 1 1.751.903 1.726 1.726 0 0 1 .17 1.354 1.739 1.739 0 0 1-.862 1.057ZM39.605 147.296a1.774 1.774 0 1 1 .68-2.411 2.065 2.065 0 0 1-.68 2.411Z"
      fill="#FFDF5F"
    />
    <path
      d="M39.813 147.475a1.773 1.773 0 1 1 2.41.679 1.897 1.897 0 0 1-2.41-.679ZM37.915 144.025a1.772 1.772 0 0 1 2.041-2.563 1.78 1.78 0 0 1 1.273 1.505 1.77 1.77 0 0 1-.904 1.751 1.709 1.709 0 0 1-1.975-.144 1.708 1.708 0 0 1-.435-.549Z"
      fill="#FFDF5F"
    />
    <path
      d="M40.852 145.744a.892.892 0 0 1-.982-.082.887.887 0 0 1 .123-1.47.745.745 0 0 1 1.015.032.745.745 0 0 1 .19.314.916.916 0 0 1-.346 1.206Z"
      fill="#FFF7E4"
    />
    <g opacity=".29">
      <path
        opacity=".29"
        d="M48.597 125.251a30.151 30.151 0 0 1 3.104 6.208c2.065 6.928-1.552 15.144-8.438 17.389a11.42 11.42 0 0 1-7.925-.347 12.47 12.47 0 0 0 12.47 3.617c6.54-2.065 9.81-9.699 7.925-16.184a27.509 27.509 0 0 0-7.136-10.683Z"
        fill="url(#paint3_linear_6616_41481)"
      />
    </g>
    <path
      d="M33.952 140.576a1.737 1.737 0 0 1-1.378-.117 1.75 1.75 0 0 1-.853-1.089 1.673 1.673 0 0 1 .558-1.932c.192-.145.413-.247.648-.299a1.72 1.72 0 0 1 .7-.084 1.733 1.733 0 0 1 1.53 1.29 1.845 1.845 0 0 1-1.205 2.231Z"
      fill="#FFDF5F"
    />
    <path
      d="M31.887 143.167v.097c.222.016.444-.017.652-.097a1.757 1.757 0 0 0 1.089-.861 1.75 1.75 0 0 0 .116-1.384 1.69 1.69 0 0 0-2.245-1.205l-.207.097a1.52 1.52 0 0 0-.139-.347h.18a1.757 1.757 0 0 0 1.321-1.987 1.761 1.761 0 0 0-1.875-1.477c.031 2.428.404 4.84 1.108 7.164Z"
      fill="#FFDF5F"
    />
    <path
      d="M32.414 139.204a1.164 1.164 0 0 0-1.206-.693 1.12 1.12 0 0 0-.221.125c0 .609.138 1.205.25 1.773a.818.818 0 0 0 .484 0 .983.983 0 0 0 .693-1.205Z"
      fill="#FFF7E4"
    />
    <path
      d="M50.26 150.843a1.702 1.702 0 0 0-2.355-.609l-.25.18a.73.73 0 0 0-.097-.18 1.77 1.77 0 0 0-2.476-.817 1.772 1.772 0 0 0-.614 2.535l.084.124h-.084c-.219.129-.412.298-.568.499a10.697 10.697 0 0 0 3.658-.499c.952-.288 1.86-.702 2.702-1.233Z"
      fill="#FFDF5F"
    />
    <path
      d="M47.53 152.132a.773.773 0 0 0-.997 0 .747.747 0 0 0-.416.346c.477-.089.95-.205 1.414-.346Z"
      fill="#FFF7E4"
    />
    <path
      d="M234.18 129.145c3.436 8.701-.443 19.592-9.131 22.903-8.687 3.312-18.885-1.912-22.335-10.613-3.45-8.701-4.365-25.702 6.36-29.859 10.003-3.866 21.808 8.882 25.106 17.569Z"
      fill="url(#paint4_linear_6616_41481)"
    />
    <path
      d="M234.18 129.145c3.436 8.701-.443 19.592-9.131 22.903-8.687 3.312-18.885-1.912-22.335-10.613-3.45-8.701-4.365-25.702 6.36-29.859 10.003-3.866 21.808 8.882 25.106 17.569Z"
      fill="url(#paint5_linear_6616_41481)"
    />
    <path
      d="M224.065 120.332a1.244 1.244 0 0 1-.568 1.469 1.124 1.124 0 0 1-.852.02 1.124 1.124 0 0 1-.616-.588 1.113 1.113 0 0 1 .568-1.469 1.136 1.136 0 0 1 1.468.568ZM228.721 133.606a1.29 1.29 0 0 1-.568 1.482 1.261 1.261 0 0 1-1.483-.568 1.247 1.247 0 0 1 .568-1.469 1.124 1.124 0 0 1 1.483.555ZM214.186 124.766a1.248 1.248 0 0 1-.568 1.469 1.31 1.31 0 0 1-1.469-.568 1.263 1.263 0 0 1 .568-1.469 1.113 1.113 0 0 1 .853-.022 1.113 1.113 0 0 1 .616.59ZM219.257 137.666c.093.202.124.427.088.646a1.116 1.116 0 0 1-1.501.873 1.121 1.121 0 1 1 1.413-1.519ZM210.154 140.936a1.109 1.109 0 1 1-1.482-.568 1.118 1.118 0 0 1 1.229.21c.107.102.193.223.253.358ZM204.834 127.441a1.29 1.29 0 0 1-.568 1.482 1.127 1.127 0 0 1-1.23-.21 1.126 1.126 0 0 1-.276-1.217 1.123 1.123 0 0 1 .591-.623 1.024 1.024 0 0 1 1.483.568Z"
      fill="#F59DA7"
    />
    <path
      d="M209.877 115.982a42.199 42.199 0 0 1-7.468 2.12c-.45.98-.82 1.995-1.109 3.034a49.15 49.15 0 0 0 9.575-2.549 57.311 57.311 0 0 0 10.059-5.196 20.258 20.258 0 0 0-2.951-1.483 50.885 50.885 0 0 1-8.106 4.074ZM200.552 131.888c.083.929.208 1.829.36 2.771a67.244 67.244 0 0 0 14.66-3.907 89.673 89.673 0 0 0 15.241-7.87 42.084 42.084 0 0 0-1.718-2.272 81.765 81.765 0 0 1-14.59 7.593 62.013 62.013 0 0 1-13.953 3.685ZM235.413 135.754a17.56 17.56 0 0 0-.277-3.187 82.431 82.431 0 0 1-16.086 8.563 62.307 62.307 0 0 1-14.438 3.824 17.86 17.86 0 0 0 1.995 2.453 66.5 66.5 0 0 0 13.426-3.672 92.628 92.628 0 0 0 15.38-7.981Z"
      fill="#75A5DE"
    />
    <path
      d="m224.62 116.065-4.67-.471-2.923 5.542-6.138-1.386-3.007 4.988-5.335-2.341-1.967 2.355a25.642 25.642 0 0 0-.166 2.162l2.535-3.09 5.321 2.494 3.145-5.043 6.263 1.385 2.937-5.695 5.542.555c-.484-.527-1.011-.998-1.537-1.455ZM233.182 126.914a30.813 30.813 0 0 0-.803-1.482l-1.247 3.547-6.208-.624-2.923 5.542-6.138-1.385-2.993 4.849-5.335-2.23-3.657 4.503-2.203-1.386c.18.651.36 1.275.568 1.871l1.884 1.219 3.81-4.628 5.473 2.369 3.007-4.988 6.277 1.386 2.937-5.681 6.36.499 1.191-3.381ZM230.203 141.005l-2.937 5.542-6.152-1.302-3.007 4.849-5.306-2.355-2.259 2.771c.36.222.734.416 1.109.609l1.551-1.828 5.543 2.355 3.02-5.127 6.277 1.386 2.937-5.681 3.284.319c.15-.381.28-.769.388-1.164l-4.448-.374Z"
      fill="#FFFAEC"
    />
    <path
      opacity=".1"
      d="M204.39 156.066c0 .97-5.404 1.663-12.054 1.663-6.651 0-12.055-.831-12.055-1.663 0-.831 5.404-1.662 12.055-1.662 6.65 0 12.054.693 12.054 1.662Z"
      fill="#000"
    />
    <path
      d="M210.625 136.363c0 10.115-8.175 19.537-18.289 19.537-10.115 0-18.29-9.422-18.29-19.537 0-10.114 5.82-27.572 18.29-27.572 11.5.013 18.289 17.458 18.289 27.572Z"
      fill="url(#paint6_linear_6616_41481)"
    />
    <path
      d="M181.556 114.264a17.72 17.72 0 0 0-.997 1.261 72.088 72.088 0 0 0 11.915 1.025 84.757 84.757 0 0 0 11.39-.804 22.187 22.187 0 0 0-.984-1.247c-3.452.428-6.927.65-10.406.665a68.622 68.622 0 0 1-10.918-.9Z"
      fill="#FFC665"
    />
    <path
      d="M208.824 144.483a19.844 19.844 0 0 0 1.801-8.119v-.707a89.38 89.38 0 0 1-18.608 2.092 65.627 65.627 0 0 1-18.012-2.591v1.206c.014 2.706.585 5.38 1.676 7.856a74.645 74.645 0 0 0 16.336 1.843 94.856 94.856 0 0 0 16.807-1.58Z"
      fill="#DC5B29"
    />
    <path
      d="M182.152 152.409a16.63 16.63 0 0 0 20.409 0 85.55 85.55 0 0 1-10.918.734 65.99 65.99 0 0 1-9.491-.734ZM175.391 143.444c.359.954.79 1.881 1.288 2.771a72.262 72.262 0 0 0 15.518 1.732 91.962 91.962 0 0 0 15.616-1.386 20.95 20.95 0 0 0 1.385-2.674 91.372 91.372 0 0 1-17.181 1.621 69.698 69.698 0 0 1-16.626-2.064Z"
      fill="#FFC665"
    />
    <path
      d="M193.583 141.768a1.246 1.246 0 0 1-2.47.243 1.245 1.245 0 0 1 1.223-1.49 1.246 1.246 0 0 1 1.247 1.247ZM198.432 141.629a1.249 1.249 0 0 1-1.49 1.223 1.245 1.245 0 0 1-.909-1.7 1.247 1.247 0 0 1 2.399.477ZM203.102 141.075a1.246 1.246 0 0 1-2.47.243 1.245 1.245 0 0 1 1.223-1.49 1.47 1.47 0 0 1 1.247 1.247ZM207.258 140.673a1.249 1.249 0 0 1-1.49 1.223 1.245 1.245 0 0 1-.909-1.7 1.253 1.253 0 0 1 1.152-.77 1.247 1.247 0 0 1 1.247 1.247ZM183.884 141.075a1.246 1.246 0 1 1-2.492 0 1.246 1.246 0 0 1 2.492 0ZM177.926 141.491a1.248 1.248 0 1 0-.002-2.495 1.248 1.248 0 0 0 .002 2.495ZM188.595 141.629a1.246 1.246 0 0 1-2.47.243 1.245 1.245 0 0 1 1.223-1.49 1.154 1.154 0 0 1 .909.337 1.157 1.157 0 0 1 .338.91ZM180.794 115.206a25.347 25.347 0 0 0-1.856 2.771 73.115 73.115 0 0 0 13.536 1.303 90.071 90.071 0 0 0 13.052-.998 28.607 28.607 0 0 0-1.856-2.84 84.53 84.53 0 0 1-11.196.789 67.265 67.265 0 0 1-11.68-1.025Z"
      fill="#FFF7E4"
    />
    <path
      d="M176.485 123.367a35.752 35.752 0 0 0-.748 2.244 71.615 71.615 0 0 0 16.738 2.023 92.636 92.636 0 0 0 16.418-1.524 34.648 34.648 0 0 0-.789-2.314 90.07 90.07 0 0 1-15.768 1.483 69.15 69.15 0 0 1-15.851-1.912Z"
      fill="#FFC665"
    />
    <path
      d="M175.889 125.113a41.64 41.64 0 0 0-1.482 6.581 72.446 72.446 0 0 0 18.012 2.314 91.752 91.752 0 0 0 17.818-1.801 40.826 40.826 0 0 0-1.552-6.609 87.88 87.88 0 0 1-16.405 1.621 67.587 67.587 0 0 1-16.391-2.106Z"
      fill="#FFF7E4"
    />
    <path
      d="M193.583 130.821a1.251 1.251 0 0 1-.77 1.152 1.25 1.25 0 0 1-1.359-.27 1.252 1.252 0 0 1-.27-1.359 1.244 1.244 0 0 1 1.152-.77 1.382 1.382 0 0 1 1.247 1.247ZM198.571 130.821a1.251 1.251 0 0 1-.77 1.152 1.25 1.25 0 0 1-1.7-.909 1.244 1.244 0 0 1 2.105-1.125c.234.234.365.551.365.882ZM203.102 130.267a1.246 1.246 0 0 1-2.47.243 1.245 1.245 0 0 1 1.223-1.49c.831.138 1.247.554 1.247 1.247ZM206.192 130.974a1.246 1.246 0 1 0 0-2.492 1.246 1.246 0 0 0 0 2.492ZM182.775 131.375a1.247 1.247 0 1 0 .001-2.493 1.247 1.247 0 0 0-.001 2.493ZM179.173 129.435a1.247 1.247 0 1 1-2.493.001 1.247 1.247 0 0 1 2.493-.001ZM188.734 130.821a1.252 1.252 0 0 1-.77 1.152 1.253 1.253 0 0 1-1.359-.27 1.249 1.249 0 0 1 .882-2.129 1.246 1.246 0 0 1 1.247 1.247Z"
      fill="#FFA752"
    />
    <path
      opacity=".1"
      d="M173.922 141.407c0 5.362-23.555 9.186-52.652 9.186s-52.651-4.586-52.651-9.186c0-5.348 23.554-9.186 52.651-9.186 29.097 0 52.652 3.838 52.652 9.186Z"
      fill="#000"
    />
    <path
      opacity=".1"
      d="M63.59 138.469c0 .43 2.77.873 6.013.873 3.242 0 6-.443 6-.873 0-.429-2.772-.873-6-.873-3.229 0-6.014.43-6.014.873Z"
      fill="#000"
    />
    <path
      d="M60.97 130.281c.874 5.015 5.792 8.95 10.808 7.967 5.016-.984 8.189-6.332 7.316-11.237-.873-4.905-5.348-13.094-11.459-11.999-5.791 1.094-7.537 10.253-6.664 15.269Z"
      fill="#FC0"
    />
    <path
      d="M75.92 119.528c-.193-.277-.387-.554-.595-.817l-2.854 3.381-4.504-2.051-3.145 3.339-3.048-2.203c-.097.305-.194.61-.277.929l3.34 2.549 3.31-3.381 4.6 2.092 3.174-3.838ZM76.752 130.309l-3.187 3.782-4.503-2.037-3.131 3.326-3.7-2.771-.346.263c.181.363.385.715.61 1.053l3.436 2.729 3.297-3.394 4.6 2.078 3.229-3.879 1.593.512c.111-.305.194-.623.277-.942l-2.175-.72Z"
      fill="#FFFAEC"
    />
    <path
      d="M65.39 119.889a1 1 0 0 1-.692 1.039.874.874 0 0 1-1.033-.685.878.878 0 0 1 .686-1.033.868.868 0 0 1 .665.118.857.857 0 0 1 .374.561ZM64.296 128.674a.999.999 0 0 1-.679 1.039.981.981 0 0 1-1.04-.693 1.01 1.01 0 0 1 .68-1.039.89.89 0 0 1 1.039.693ZM70.85 128.674a.885.885 0 0 1-1.34.854.89.89 0 0 1-.392-.508.996.996 0 0 1 .692-1.039.903.903 0 0 1 1.04.693ZM73.025 118.85a.871.871 0 0 1-.848 1.047.87.87 0 0 1-.866-1.032.876.876 0 0 1 1.018-.699.864.864 0 0 1 .696.684ZM76.156 127.385a.968.968 0 0 1-.679 1.039.878.878 0 1 1-.36-1.718.888.888 0 0 1 1.04.679ZM70.711 136.115a.982.982 0 0 1-.693 1.039.894.894 0 0 1-.342.001.878.878 0 0 1 .338-1.724.874.874 0 0 1 .697.684Z"
      fill="#E8644A"
    />
    <g opacity=".3">
      <path
        opacity=".3"
        d="M61.885 120.817a19.4 19.4 0 0 0 .11 5.127c.985 5.348 6.222 9.602 11.57 8.618a8.462 8.462 0 0 0 5.127-2.937 9.39 9.39 0 0 1-6.928 6.651c-5.016.872-9.823-3.049-10.807-7.968-.377-3.193-.06-6.43.928-9.491Z"
        fill="#878786"
      />
    </g>
    <path
      d="M169.225 133.87c3.173 4.032-.956 8.188-6.596 11.264-5.639 3.076-12.47 2.979-14.146 0-.956-1.801.111-4.461 2.134-6.484 2.646-2.771 5.625-3.395 7.856-4.891 2.23-1.497 3.519-2.868 4.891-3.118 2.327-.623 4.253.984 5.861 3.229ZM132.327 88.977l7.122 49.437-21.269 2.66a9.687 9.687 0 0 1-1.801.111c-6.928.319-6.928.318-7.87.429-4.461.097-9.13-.11-12.969-.11l-5.099-.541c-2.66-.416-6.068-.845-8.077-2.549-1.802-1.386-2.772-5.307-3.728-7.662-3.824-9.783-3.186-20.784.527-30.718.222-.527.43-1.04.651-1.705a25.176 25.176 0 0 1 19.717-16.058h.319a25.645 25.645 0 0 1 16.806 2.979l.527.332c2.231 1.261 4.351 2.854 6.803 3.395 2.761.464 5.58.464 8.341 0Z"
      fill="#C7C8C7"
    />
    <path
      d="M96.926 132.679a12.47 12.47 0 0 0-7.343.526c-4.157 1.704-8.064 5.113-7.26 5.736 2.008 1.705 5.32 2.079 8.077 2.564l5.099.526c3.838 0 8.507.208 12.969.111.956 0 .956 0 7.773-.429.623 0 1.164-.097 1.801-.097l16.156-.97 10.53-1.705 3.339-4.032-12.858 3.409.541 1.593-13.856-18.012-5.182 6.706a34.368 34.368 0 0 1-8.313 5.625c-1.926.735-4.157 1.04-7.87-.54a10.656 10.656 0 0 0-1.594-.526l-2.009-.485ZM165.913 130.974c.651 1.178-4.669 5.196-8.189 8.826-3.283 3.394-7.011 2.549-7.856.637-.845-1.912.956-3.394 5.543-5.431 5.403-2.328 9.795-5.418 10.502-4.032Z"
      fill="#B7B7B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.654 82.784a25.617 25.617 0 0 0-11.943-.582h-.319A25.177 25.177 0 0 0 80.285 97.72c.707 4.725 5.681 7.842 12.47 6.304 11.417-2.494 17.722-17.388 18.899-21.24Z"
      fill="#B7B7B7"
    />
    <path
      d="M104.255 126.817c4.711 0 8.508-3.104 8.508-7.025 0-3.921-3.797-7.011-8.508-7.011-4.71 0-8.493 3.118-8.493 7.011 0 3.894 3.81 7.025 8.493 7.025ZM136.359 93.231l2.342-1.593-3.935-4.24c-1.164-.97-1.912-.222-1.912-.222a2.687 2.687 0 0 1 2.355 2.231c.055.255.129.505.222.748l.928 3.076Z"
      fill="#B7B7B7"
    />
    <path
      d="M80.119 123.062s-14.673 4.365-15.56 19.398c0 0-1.178 14.534 18.012 17.541 0 0 19.024 4.254 20.521-5.542 0 0 1.163-11.417-7.122-9.339-3.409.527-9.7.845-12.332-.429 0 0-4.032-2.868.845-7.759l-4.364-13.87Z"
      fill="#C7C8C7"
    />
    <path
      d="M88.1 134.022s-12.636 1.275-10.198 8.507c0 0 1.04 2.647 7.648 2.771a5.706 5.706 0 0 1-2.23-.956c-.956-.956-2.231-3.297.526-6.692a31.121 31.121 0 0 1 4.254-3.63Z"
      fill="#B7B7B7"
    />
    <path
      d="M142.816 144.012c.72-3.381-3.852-7.261-10.226-8.591-6.373-1.33-12.137.291-12.858 3.686-.72 3.394 3.866 7.26 10.24 8.576 6.373 1.317 12.165-.318 12.844-3.671Z"
      fill="#C7C8C7"
    />
    <path
      d="M142.137 142.169c-.748 1.815-4.794 2.078-8.078-1.04-2.979-2.854-4.905-5.182-4.572-5.944.097-.221 2.23-.748 6.484 1.04a16.606 16.606 0 0 1 3.395 1.801c1.981 1.662 3.283 2.84 2.771 4.143Z"
      fill="#B7B7B7"
    />
    <path
      d="M146.03 139.065c14.632 0 26.451-12.193 26.451-27.227 0-15.033-11.819-27.212-26.451-27.212-14.631 0-26.478 12.193-26.478 27.212 0 15.02 11.874 27.227 26.478 27.227Z"
      fill="#E3E3E3"
    />
    <path
      d="M159.553 117.271c.305 0 .624-.111.846-.111h2.009c.429 0 .859.111 1.274.111.358.006.711.081 1.04.221l1.039.208.111-.429-1.04-.208c-.318-.111-.748-.111-1.039-.208h-.208c-.318 0-.748-.111-1.039-.111h-2.009c-.429 0-.859.111-1.275.111l-.748.097a3.648 3.648 0 0 0-.956.208l-.318.111a6.136 6.136 0 0 0-1.289.429l-.416.208.111.208v.194h1.483c.646.043 1.286.15 1.912.318.429.097.748.097 1.164.208l.429.097 1.912.652h.111c.659.23 1.298.513 1.912.845l.748.429.208-.429-.956-.527c-.526-.221-1.039-.54-1.593-.748l-.43-.222-1.94-.623-.318-.111-1.386-.319-.748-.097-.956-.124.859-.305 1.496-.083ZM143.425 117.686c-.318 0-.637-.111-.859-.111h-2.05c-.43 0-.845.111-1.275.111-.357.006-.71.081-1.039.221l-2.12.735-.208-.416 2.231-.748c.319-.111.734-.111 1.025-.222h.236c.332 0 .748-.097 1.039-.097h2.009c.43 0 .845.097 1.275.097l.748.111c.326.028.648.098.956.208l.319.111c.437.097.864.236 1.274.415l.43.222-.111.208v.222h-1.496c-.641.051-1.276.157-1.899.318-.429.111-.748.111-1.177.208l-.43.111-1.912.637c-.654.242-1.293.524-1.912.845l-.845.541-.222-.43 1.039-.637c.527-.208 1.039-.54 1.594-.748l.415-.208 1.926-.637.319-.111 1.386-.319.748-.097.942-.125-.845-.304-1.511-.111Z"
      fill="#C7C7C7"
    />
    <path
      d="M159.539 119.598c-.207-.097-.415 0-.415.208a3.951 3.951 0 0 1-5.155 2.134 4.047 4.047 0 0 1-1.981-1.801.112.112 0 0 1-.097-.111.096.096 0 0 0 .005-.082.079.079 0 0 0-.024-.035.103.103 0 0 0-.036-.022h-.208a.117.117 0 0 1-.037.07.108.108 0 0 1-.074.027.098.098 0 0 0-.041.009.097.097 0 0 0-.033.024.102.102 0 0 0-.02.037.094.094 0 0 0-.003.041 3.976 3.976 0 0 1-3.201 2.328 4.158 4.158 0 0 1-4.738-2.009c-.111-.222-.319-.222-.527-.111-.208.111-.208.319-.111.526a4.994 4.994 0 0 0 4.254 2.439c.427.024.856-.009 1.275-.097a5.105 5.105 0 0 0 3.505-2.231 4.493 4.493 0 0 0 3.617 2.079 3.29 3.29 0 0 0 1.039-.125 4.16 4.16 0 0 0 3.408-2.854.615.615 0 0 0-.142-.275.618.618 0 0 0-.26-.169Z"
      fill="#8D8D8D"
    />
    <path d="M148.067 116.301h6.775l-3.117 3.838" fill="#C02A23" />
    <path
      d="M142.386 110.565a1.702 1.702 0 0 1-1.593 1.801h-.042a1.776 1.776 0 0 1-1.704-1.801 1.705 1.705 0 0 1 3.409 0h-.07ZM161.659 110.565a1.695 1.695 0 0 1-.42 1.233 1.685 1.685 0 0 1-1.173.568h-.097a1.774 1.774 0 0 1-1.704-1.801 1.701 1.701 0 0 1 1.572-1.752 1.702 1.702 0 0 1 1.822 1.488.835.835 0 0 1 0 .264Z"
      fill="#000"
    />
    <path
      d="M58.698 43.586c-.402-1.011-1.385-5.002 1.87-4.517 2.883.416 1.622 3.7 1.553 3.963-.07.263 2.272-2.397 3.81-.735 2.508 2.688-2.175 3.77-2.605 3.88-.43.11 4.6.319 2.993 3.616-1.22 2.494-3.921.762-5.14-.623 0 0 .748 4.877-2.218 4.364-4.156-.596-2.313-3.824-1.538-5.085 0 0-3.602 3.007-4.53-.568-.347-1.385 1.385-2.161 3.491-2.12 0 0-4.309-1.191-1.884-3.949 1.898-1.87 4.198 1.774 4.198 1.774Z"
      fill="#EAADB7"
    />
    <path d="M58.892 46.523a1.386 1.386 0 1 1 1.386 1.109 1.469 1.469 0 0 1-1.386-1.109Z" fill="#fff" />
    <path
      d="M42.071 87.924c-.401-1.012-1.385-5.002 1.87-4.517 2.883.416 1.622 3.7 1.553 3.963-.07.263 2.272-2.397 3.81-.735 2.508 2.688-2.175 3.769-2.605 3.88-.43.11 4.6.319 2.993 3.616-1.22 2.494-3.921.762-5.14-.623 0 0 .748 4.877-2.217 4.364-4.157-.596-2.314-3.824-1.538-5.085 0 0-3.603 3.007-4.531-.568-.346-1.385 1.386-2.161 3.492-2.12 0 0-4.31-1.191-1.885-3.949 1.898-1.87 4.198 1.774 4.198 1.774Z"
      fill="#EAADB7"
    />
    <path d="M42.265 90.861a1.385 1.385 0 1 1 1.386 1.109 1.469 1.469 0 0 1-1.386-1.109Z" fill="#fff" />
    <path
      d="M103.036 61.599c-.401-1.012-1.385-5.002 1.871-4.517 2.882.415 1.621 3.7 1.552 3.962-.07.264 2.272-2.397 3.81-.734 2.508 2.688-2.175 3.769-2.605 3.88-.429.11 4.6.318 2.993 3.616-1.219 2.494-3.921.762-5.14-.623 0 0 .748 4.877-2.217 4.364-4.157-.596-2.314-3.824-1.538-5.085 0 0-3.603 3.007-4.531-.568-.346-1.386 1.385-2.162 3.491-2.12 0 0-4.309-1.192-1.884-3.949 1.898-1.87 4.198 1.774 4.198 1.774Z"
      fill="#EAADB7"
    />
    <path
      d="M103.23 64.536a1.39 1.39 0 0 1 .635-1.46 1.386 1.386 0 1 1 .751 2.568 1.468 1.468 0 0 1-1.386-1.108Z"
      fill="#fff"
    />
    <path
      d="M152.917 28.345c-.402-1.011-1.386-5.002 1.87-4.517 2.882.416 1.621 3.7 1.552 3.963-.069.263 2.272-2.397 3.81-.734 2.508 2.688-2.175 3.768-2.605 3.88-.429.11 4.6.318 2.993 3.616-1.219 2.494-3.921.762-5.14-.624 0 0 .748 4.877-2.217 4.365-4.157-.596-2.314-3.825-1.538-5.085 0 0-3.603 3.006-4.531-.569-.346-1.385 1.386-2.161 3.492-2.12 0 0-4.309-1.191-1.885-3.948 1.899-1.87 4.199 1.773 4.199 1.773Z"
      fill="#EAADB7"
    />
    <path d="M153.111 31.282a1.385 1.385 0 1 1 1.454 1.109 1.47 1.47 0 0 1-1.454-1.109Z" fill="#fff" />
    <path
      d="M205.568 83.768c-.402-1.012-1.385-5.002 1.871-4.517 2.882.415 1.621 3.7 1.551 3.962-.069.264 2.273-2.397 3.811-.734 2.508 2.688-2.176 3.769-2.605 3.88-.43.11 4.6.318 2.993 3.616-1.22 2.494-3.921.762-5.141-.624 0 0 .748 4.878-2.217 4.365-4.156-.596-2.314-3.824-1.538-5.085 0 0-3.602 3.007-4.53-.568-.347-1.386 1.385-2.162 3.491-2.12 0 0-4.309-1.192-1.884-3.949 1.898-1.87 4.198 1.774 4.198 1.774Z"
      fill="#EAADB7"
    />
    <path d="M205.762 86.705a1.385 1.385 0 1 1 1.455 1.109 1.468 1.468 0 0 1-1.455-1.109Z" fill="#fff" />
    <path
      opacity=".1"
      d="M177.233 161.457c0 .554-3.464 1.108-7.62 1.108-4.157 0-7.621-.554-7.621-1.108 0-.555 3.464-1.109 7.621-1.109 4.156 0 7.62.513 7.62 1.109Z"
      fill="#000"
    />
    <path
      d="M180.559 151.023c-1.109 6.374-7.344 11.362-13.717 10.115-6.374-1.247-10.392-8.037-9.284-14.272 1.109-6.235 6.79-16.626 14.549-15.241 7.343 1.386 9.56 13.025 8.452 19.398Z"
      fill="url(#paint7_linear_6616_41481)"
    />
    <path
      d="M167.396 151.577a3.6 3.6 0 0 0 3.533-4.305 3.603 3.603 0 0 0-7.136.703 3.58 3.58 0 0 0 3.603 3.602Z"
      fill="#EAADB7"
    />
    <g opacity=".3">
      <path
        opacity=".3"
        d="M179.45 139.107a24.962 24.962 0 0 1-.138 6.513c-1.247 6.789-7.898 12.193-14.687 10.946a10.758 10.758 0 0 1-6.513-3.741 11.937 11.937 0 0 0 8.868 8.451c6.374 1.109 12.47-3.879 13.717-10.114.46-4.061.035-8.174-1.247-12.055Z"
        fill="#4D6BA0"
      />
    </g>
    <path
      d="M179.935 140.88a16.49 16.49 0 0 0-3.159-6.415 3.6 3.6 0 0 0-2.416 3.526 3.601 3.601 0 0 0 5.575 2.889ZM180.559 151.023c.171-1.007.259-2.027.263-3.048a3.769 3.769 0 0 0-1.386-.277 3.591 3.591 0 1 0-.277 7.177 11.968 11.968 0 0 0 1.4-3.852ZM171.83 157.396a3.606 3.606 0 0 0-3.603 3.602v.305a11.08 11.08 0 0 0 6.775-1.912 3.594 3.594 0 0 0-3.172-1.995ZM160.509 157.424a3.602 3.602 0 0 0-1.288-6.928 3.444 3.444 0 0 0-1.677.443 13.121 13.121 0 0 0 2.965 6.485ZM160.371 139.287a3.584 3.584 0 0 0 2.854 1.847 3.588 3.588 0 0 0 1.219-7.043 19.716 19.716 0 0 0-4.073 5.196Z"
      fill="#EAADB7"
    />
    <path
      d="M166.495 100.034c1.663-3.38-1.039-8.133-6.138-10.627-5.099-2.494-10.502-1.788-12.165 1.593-1.663 3.381 1.039 8.106 6.138 10.614 5.099 2.507 10.503 1.787 12.165-1.58Z"
      fill="#C7C7C7"
    />
    <path
      d="M167.479 41.217c-4.559 3.104-5.459 8.009-6.512 10.78-3.34 8.48-6.776 28.418-7.663 33.739a25.894 25.894 0 0 1 9.478 4.489 70.163 70.163 0 0 0 14.784-22.17 31.4 31.4 0 0 0 1.552-3.588l-11.639-23.25ZM143.855 85.25c-2.355-14.52-10.96-63.639-19.98-65.121-10.433-1.719-17.527 13.384 7.995 69.97a25.977 25.977 0 0 1 11.985-4.849Z"
      fill="#A06E4B"
    />
    <path
      d="M135.611 87.743a25.341 25.341 0 0 1 6.526-2.286c-1.677-6.22-11.306-40.721-13.08-45.432-3.935-10.198-9.38-17.126-6.318-.319.235 1.635 7.44 35.04 12.872 48.037Z"
      fill="url(#paint8_radial_6616_41481)"
    />
    <path
      d="M160.51 88.644c4.226-6.262 12.47-19.578 16.626-33.863l-4.78-6.249a73.833 73.833 0 0 0-3.561 6.54c-4.046 8.59-10.35 25.093-12.816 31.397a26.74 26.74 0 0 1 4.531 2.175Z"
      fill="url(#paint9_radial_6616_41481)"
    />
    <path
      d="M190.812 77.422c2.535-3.658.595-13.288-4.393-21.282 0 0-11.777-17.75-18.843-15.034-.097.111 12.428 52.458 23.236 36.316Z"
      fill="#A06E4B"
    />
    <path
      d="M125.912 96.168s-.222-.72 4.157-4.156c5.237-4.157 9.699-6.928 16.488-6.928a25.382 25.382 0 0 1 16.765 6.928 23.927 23.927 0 0 1 5.542 6.928"
      fill="none"
      stroke="#A06E4B"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path d="m166.537 101.309-8.314-8.314 6.928-8.092c1.815-1.163 2.245.527 2.245 3.284l-.859 13.122Z" fill="#E3E3E3" />
    <path d="m165.054 97.36-4.558-4.891 3.713-4.337c.845-.748 1.385-.637 1.385 1.483l-.54 7.745Z" fill="#C7C7C7" />
    <path d="m130.263 97.276 9.865-6.124-5.944-6.47c-1.802-1.594-3.603-.749-3.824 1.69l-.097 10.904Z" fill="#E3E3E3" />
    <path
      d="m132.285 96.002 6.471-4.018-3.935-4.254c-1.164-.956-2.328-.43-2.439 1.039l-.097 7.233ZM157.905 92.94l1.247-1.386 1.385.845 1.593 1.719.25.235 1.136.97a8.315 8.315 0 0 1 1.843 2.397l.235.43.97 1.704c.013.124.013.249 0 .374a4.768 4.768 0 0 1-.595.748l-8.064-8.036Z"
      fill="#C7C7C7"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6616_41481"
        x1="14.416"
        y1="121.608"
        x2="36.169"
        y2="143.347"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset="1" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6616_41481"
        x1="23.643"
        y1="131.389"
        x2="35.878"
        y2="143.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset="1" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6616_41481"
        x1="30.557"
        y1="131.015"
        x2="55.567"
        y2="144.206"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC83C" />
        <stop offset="1" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6616_41481"
        x1="41.392"
        y1="136.959"
        x2="55.47"
        y2="144.386"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset="1" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6616_41481"
        x1="198.368"
        y1="121.813"
        x2="233.754"
        y2="137.235"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset="1" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_6616_41481"
        x1="198.368"
        y1="121.813"
        x2="233.754"
        y2="137.235"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset="1" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_6616_41481"
        x1="177.316"
        y1="118.323"
        x2="207.106"
        y2="148.113"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset="1" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_6616_41481"
        x1="161.757"
        y1="136.017"
        x2="177.012"
        y2="158.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset="1" stopColor="#1B92B4" />
      </linearGradient>
      <radialGradient
        id="paint8_radial_6616_41481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(131.219 16.83) scale(58.554)"
      >
        <stop offset=".1" stopColor="#F9D8DC" />
        <stop offset=".77" stopColor="#F6B4BA" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_6616_41481"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(162.907 53.908) scale(38.962)"
      >
        <stop offset=".1" stopColor="#F9D8DC" />
        <stop offset=".77" stopColor="#F6B4BA" />
      </radialGradient>
    </defs>
  </SvgIcon>
)
